import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-income-verification',
  templateUrl: './icon-income-verification.component.html'
})
export class IconIncomeVerificationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
